import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    userInfo: null,
    adminStatus: false,
    indexCurrentPage:1,
    permission:null
  },
  mutations: {
    set_indexCurrentPage(state, value) {
      state.indexCurrentPage = value;
    },
    set_token(state, token) {
      state.token = token;
    },
    get_token(state){
      return state.token
    },
    del_token(state) {
      state.token = null;
    },
    set_userInfo(state, data) {
      state.userInfo = data;
    },
    get_userInfo(state){
      return state.userInfo
    },
    set_permission(state, data) {
      state.permission = data;
    },
    get_permission(state){
      return state.permission
    },
    set_adminStatus(state, data) {
      state.adminStatus = data;
    },
    del_userInfo(state) {
      state.userInfo = null;
      // return true;
    },
  },
  actions: {},
  modules: {},
});
